import { Component, OnInit } from "@angular/core";

import { AwsService } from "../../../providers/appsyncservice/aws.service";
// import { AngularFirestore } from 'angularfire2/firestore';
import { GoogleMapsAPIWrapper, MapsAPILoader } from "@agm/core";
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import "jspdf-autotable";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
declare var google: any;

@Component({
  selector: "app-drivertripdetails",
  templateUrl: "./drivertripdetails.component.html",
  styleUrls: ["./drivertripdetails.component.css"],
})
export class DrivertripdetailsComponent implements OnInit {
  hcolr: String = "#689 !important;";
  driverusers: any;
  searchFilter: any = {};
  cabmaster: any;
  count: number = 0;
  out_station_flag: number;
  month_excel_dwn: number;
  out_time_flag: number;
  cols: any[];
  id: string;
  mid: number;
  month: string;
  name: string;
  driverId: string;
  driverName: string;
  userId: string;
  userName: string;
  vehicle_no: string;
  vehicleName: string;
  latIn: string;
  longIN: string;
  p: number = 1;
  defaultWorkHr: number = 12;
  totalItem: number = 1;
  delayinms: number;

  dayval: number;
  hrval: number;
  minval: number;
  secval: number;

  overdayval: number;
  overhrval: number;
  overminval: number;
  oversecval: number;

  outdayval: number;
  outhrval: number;
  outminval: number;
  outsecval: number;

  tlduration: string;
  tloverduration: string;
  tloutduration: string;
  filterError: boolean = false;
  filterErrorAgency: boolean = false;
  loader: number = 3;

  propertyName: String = "vehicle_no";

  driverSelectedItems: any[] = [this.id, this.name];
  driverDropdownSettings = {};

  userSelectedItems: any[] = [this.id, this.name];
  userDropdownSettings = {};

  vehicleSelectedItems: any[] = [this.id, this.vehicle_no];
  vehicleDropdownSettings = {};

  trpStatusArrs: any;
  trpTypeArrs: any;
  filterDropDn: any;
  monthDropDown: any;
  displayValue: number = 0;
  tripDetails: any;
  uniquedriver: any;
  tripHeaders: any[] = [];
  nextToken: string = "";
  driverNextToken: string = "";
  rncUsersNextToken = "";
  in_time: string;
  out_time: string;
  driverTripDls: any;
  allUsers: any;
  key: string = "sno"; //set default
  reverse: boolean = false;
  addresses: any;
  addressListMap: Map<String, Object>;
  monthListMap: Map<number, String>;
  driverMap: Map<String, String>;
  metaData: any[] = [];
  agency_type: string = "";
  exportJsonData: any = {
    driver_id: String,
    driver_name: String,
    vehicle_no: String,
    start_time: String,
    end_time: String,
    worked_hours: String,
    out_station: String,
    over_time_hours: String,

    start_address: String,
    end_address: String,
    outstation_start_time: String,
    outstation_end_time: String,
    out_worked_hours: String,
    outstation_start_address: String,
    outstation_end_address: String,
    created_at: String,
  };

  constructor(
    public awserviceProvider: AwsService,
    private spinnerService: Ng4LoadingSpinnerService
  ) {
    // this.loader = 2;
    //getMetaData
    this.awserviceProvider.getMetaData().then((metadata) => {
      this.metaData = metadata;
    });

    this.initilization();
    // //console.log(now.getMonth())

    //   if (now.getDate() >= 21) {
    //     //console.log("thismoth", now.getFullYear() + "-" + now.getMonth() + "-" + 21)
    //     //console.log("nextMoth", (now.getFullYear()) + "-" + (now.getMonth()+1) + "-" + 20)
    //   }
    //   else {
    //     let prev=now.getMonth()-1;
    //     //console.log("prev", now.getFullYear()+ "-" + prev + "-" + 21)
    //     //console.log("this", now.getFullYear()+ "-" + now.getMonth()+ "-" + 20)

    //  //   this.out_time=now.getFullYear()+ "-" + prev + "-" + 21;
    //   }

    // this.awserviceProvider.getDriverAttendanceAll(this.in_time).then(async tripList => {
    //   // await this.sortinglist(tripList);
    //   //console.log("tripList", tripList.length)
    //   let trips = await this.sortinglist(tripList);
    //   this.tripDetails = this.loadDriverData(trips);
    //   // this.spinnerService.hide();
    //   //console.log("tripList", this.tripDetails.length)
    //   this.loader = this.tripDetails.length == 0 ? 0 : 2;

    // });

    //get Vehicle List
    //  this.awserviceProvider.getDriverVehcile('a').then(driverusers => {

    //  });

    //get Driver List
    let driverNextToken = "";
    this.awserviceProvider.getRncUsersByTypeByToken(3).then((driversresult) => {
      this.driverusers = driversresult.items;
      driverNextToken = driversresult.nextToken;
      //console.log(" this.driverNextToken ", driverNextToken);
      //if (this.driverNextToken!=="") {
      this.GetDriverNextToken(driverNextToken);
      // }
    });

    //get vehcile List
    this.awserviceProvider.getScCabMasterAll().then((result) => {
      this.cabmaster = result;
    });
  }

  GetDriverNextToken(driverNextToken) {
    //console.log(" this.driverusers", driverNextToken);
    if (driverNextToken != "") {
      //get Driver List
      this.awserviceProvider
        .getRncUsersByTypeByNextToken(3, driverNextToken)
        .then((driversresult) => {
          driverNextToken = "";
          this.driverusers = this.driverusers.concat(driversresult.items);

          driverNextToken = driversresult.nextToken;
          if (driverNextToken) {
            this.GetDriverNextToken(driverNextToken);
          }
        });
    }
  }

  async agencyFilter(tripList) {
    return tripList;
  }

  driverLoading(tripDl) {
    let promise = new Promise((resolve, reject) => {
      // //console.log("tripDl1",tripDl);
      this.awserviceProvider
        .getRncUsers(tripDl.driver_id)
        .then((driverusers: any) => {
          tripDl.driver = driverusers;
          // //console.log("driverusers.agency_type",driverusers);
          if (
            driverusers.agency_type == null ||
            driverusers.agency_type != this.agency_type
          ) {
            // removeFlag=true;
            resolve(null);
          } else {
            //  //console.log("tripDl2",tripDl);
            resolve(tripDl);
            // return tripDl;
          }
        })
        .catch((error) => {
          //console.log(error)
          reject(error);
        });
    });
    return promise;
  }

  async loadDriverData(tripList) {
    var driver = null;
    //  var removeFlag=false;
    let tripDlList = [];
    let cnt = 0;
    tripList.forEach(async (driverTrip) => {
      cnt++;
      let tripDl: any = {};
      tripDl = driverTrip;
      // removeFlag=false;
      // tripDl.driver ={};
      this.awserviceProvider
        .getVehicleMasterByDriver(tripDl.driver_id)
        .then((guest: any) => {
          tripDl.guest = guest.length > 0 ? guest[0] : null;
        });

      await this.driverLoading(tripDl).then((trip) => {
        ////console.log("tripDl0",trip);

        if (trip == null) {
          return;
        }
        if (driverTrip.duty_start_device_details) {
          var startDevice = JSON.parse(driverTrip.duty_start_device_details);
          driverTrip.duty_start_device_details =
            "Platform: " +
            startDevice["platform"] +
            "<br />" +
            "Brand: " +
            startDevice["manufacturer"] +
            "<br />" +
            "Model: " +
            startDevice["model"] +
            "<br />" +
            "Device ID: " +
            startDevice["uuid"];
        }
        if (driverTrip.duty_end_device_details) {
          var endDevice = JSON.parse(driverTrip.duty_end_device_details);
          driverTrip.duty_end_device_details =
            "Platform: " +
            endDevice["platform"] +
            "<br />" +
            "Brand: " +
            endDevice["manufacturer"] +
            "<br />" +
            "Model: " +
            endDevice["model"] +
            "<br />" +
            "Device ID: " +
            endDevice["uuid"];
        }
        // //console.log("driverusers",tripDl.driver.agency_type);

        tripDl.sno = this.count + 1;
        tripDl.overtime = "No";
        this.WorkedHrs(tripDl);
        // tripDl = this.nightAllowanceCal(tripDl);

        if (this.out_time_flag == 0) {
        } else {
          if (this.out_time_flag == tripDl.overtime) {
            {
            }
          } else {
            return;
          }
        }

        if (tripDl.worked_hrs != "") {
          this.totalDuration(tripDl.worked_hrs, 0);
        }
        if (tripDl.overtime_worked_hrs != "") {
          this.totalDuration(tripDl.overtime_worked_hrs, 1);
        }
        if (tripDl.out_worked_hrs != "") {
          this.totalDuration(tripDl.out_worked_hrs, 2);
        }
        this.nightAllowanceCal(tripDl);
        ////console.log(tripDl);
        ////console.log("agencyFlag",removeFlag)
        // if(!removeFlag){
        this.count++;
        //console.log("tripDl", tripDl);
        this.tripDetails.push(tripDl);
        // }
      });
      // if(tripList.length==cnt){
      //   //console.log("tripDlList",tripDlList)
      //  // this.tripDetails = this.tripDetails.concat(tripDlList);
      //   //return tripDlList;
      // }
    });

    // //console.log("tripDlList",tripDlList)
  }

  searchData() {
    this.nextToken = "";
    this.count = 0;
    //this.rncUsersNextToken="";
    this.loader = 1;
    this.tlduration = "";
    this.tloverduration = "";
    this.tloutduration = "";
    this.consolidatedInit();

    if (this.in_time == "") {
      this.filterError = true;
      return;
    }
    if (this.agency_type == "") {
      this.filterErrorAgency = true;
      return;
    }

    this.searchFilter.drivers = this.driverSelectedItems;
    this.searchFilter.vehicles = this.vehicleSelectedItems;
    this.searchFilter.dutyStart = this.in_time;
    this.searchFilter.dutyEnd = this.out_time;
    this.searchFilter.outStation =
      this.out_station_flag == 0 ? "" : this.out_station_flag;
    //console.log(" this.searchFilter", this.searchFilter)
    ////console.log("this.searchFilter",this.searchFilter)
    this.searchDataNextToken();
  }

  searchDataNextToken() {
    //console.log("this.next", this.nextToken)
    if (this.nextToken == "" || this.nextToken == null) {
      this.tripDetails = [];
    }

    this.awserviceProvider
      .driverAttendanceFilter(this.searchFilter, this.nextToken)
      .then(async (res: any) => {
        let trips = await this.sortinglist(res.items, 1);
        if (res.nextToken != null) {
          this.nextToken = res.nextToken;
          //console.log("res",res);
          this.searchDataNextToken();
        }
        this.loadDriverData(trips);

        //this.tripDetails = this.tripDetails.concat(this.loadDriverData(trips));
        this.loader = this.tripDetails.length == 0 ? 0 : 2;
      });
  }

  totalDuration(duration, flag) {
    // 1: total 2: Overtime 3: outstation
    let days = 0;
    let hours = 0;
    let min = 0;
    let sec = 0;
    let splithr = [];
    let splitdays = [];
    if (duration.length <= 8) {
      splithr = duration.split(":", 3);
      hours = parseInt(splithr[0]);
      min = parseInt(splithr[1]);
      sec = parseInt(splithr[2]);
    } else if (duration.length > 8) {
      splitdays = duration.split(" ", 3);
      splithr = splitdays[2].split(":", 3);
      days = parseInt(splitdays[0]);
      hours = parseInt(splithr[0]);
      min = parseInt(splithr[1]);
      sec = parseInt(splithr[2]);
    }

    if (flag == 0) {
      this.dayval += days;
      this.hrval += hours;
      this.minval += min;
      this.secval += sec;

      if (this.secval >= 60) {
        this.minval += Math.floor(this.secval / 60);
        this.secval = this.secval % 60;
      }
      if (this.minval >= 60) {
        this.hrval += Math.floor(this.minval / 60);
        this.minval = this.minval % 60;
      }
      if (this.hrval >= 24) {
        this.dayval += Math.floor(this.hrval / 24);
        this.hrval = this.hrval % 24;
      }
      this.tlduration = "";
      let grammer = this.dayval > 1 ? "s " : "";
      let diffDaylabel = this.dayval + " Day" + grammer;
      this.tlduration =
        diffDaylabel + this.hrval + ":" + this.minval + ":" + this.secval;
    } else if (flag == 1) {
      this.overdayval += days;
      this.overhrval += hours;
      this.overminval += min;
      this.oversecval += sec;

      if (this.oversecval >= 60) {
        this.overminval += Math.floor(this.oversecval / 60);
        this.oversecval = this.oversecval % 60;
      }
      if (this.overminval >= 60) {
        this.overhrval += Math.floor(this.overminval / 60);
        this.overminval = this.overminval % 60;
      }
      if (this.overhrval >= 24) {
        this.overdayval += Math.floor(this.overhrval / 24);
        this.overhrval = this.overhrval % 24;
      }

      this.tloverduration = "";
      let grammer = this.overdayval > 1 ? "s " : "";
      let diffDaylabel = this.overdayval + " Day" + grammer;
      this.tloverduration =
        diffDaylabel +
        this.overhrval +
        ":" +
        this.overminval +
        ":" +
        this.oversecval;
    } else if (flag == 2) {
      this.outdayval += days;
      this.outhrval += hours;
      this.outminval += min;
      this.outsecval += sec;

      if (this.outsecval >= 60) {
        this.outminval += Math.floor(this.outsecval / 60);
        this.outsecval = this.outsecval % 60;
      }
      if (this.outminval >= 60) {
        this.outhrval += Math.floor(this.outminval / 60);
        this.outminval = this.outminval % 60;
      }
      if (this.outhrval >= 24) {
        this.outdayval += Math.floor(this.outhrval / 24);
        this.outhrval = this.outhrval % 24;
      }

      this.tloutduration = "";
      let grammer = this.outdayval > 1 ? "s " : "";
      let diffDaylabel = this.outdayval + " Day" + grammer;

      this.tloutduration =
        diffDaylabel +
        this.outhrval +
        ":" +
        this.outminval +
        ":" +
        this.outsecval;
    }
  }

  async exportToPdf() {
    //this.spinnerService.show();
    var getColumns = [
      { title: "SNO", dataKey: "sno" },
      { title: "Driver\nID", dataKey: "driver_id" },
      // { title: "Driver\nName", dataKey: "driver_name" },
      { title: "Vehicle\nNo", dataKey: "vehicle_no" },
      { title: "Start\nTime", dataKey: "start_time" },
      { title: "End\nTime", dataKey: "end_time" },
      { title: "Worked\nHours", dataKey: "worked_hours" },
      { title: "Over\ntime", dataKey: "over_time" },
      { title: "Overtime\nDuration", dataKey: "overtime_duration" },
      // { title: "Overime\n(Duration)", dataKey: "overtime_duration" },
      { title: "Dinner\nAllowance", dataKey: "dinner_allowance" },
      { title: "Holiday", dataKey: "holiday" },
      { title: "Start\nAddress", dataKey: "start_address" },
      { title: "End\nAddress", dataKey: "end_address" },
      { title: "OS\nStart", dataKey: "outstation_start_time" },
      { title: "OS\nEnd", dataKey: "outstation_end_time" },
      { title: "OS\nDuration", dataKey: "outstation_workedhours" },
      { title: "OS\nStart address", dataKey: "outstation_start_address" },
      { title: "OS\nEnd address", dataKey: "outstation_end_address" },
      { title: "Start\nDevice Details", dataKey: "duty_start_device_details" },
      { title: "End\nDevice Details", dataKey: "duty_end_device_details" },
      { title: "Created\nAt", dataKey: "created_at" },
    ];

    let dateFormat = require("dateformat");
    let now = new Date();
    let reportDate = dateFormat(now, "yyyy-mm-dd");
    var pdfsize = "a3";
    //portrait landscape
    //pt mm cm
    var doc = new jsPDF("l", "pt", pdfsize);
    doc.setProperties({
      title: "Driver Attendance Report",
      subject: "Driver Attendance",
      //  author: 'James Hall',
      //  keywords: 'generated, javascript, web 2.0, ajax',
      creator: "Driver Attendance",
    });
    doc.text(20, 20, "Driver Attendance Report");
    doc.text(20, 40, "Date : " + reportDate);
    //doc.text(20, 60, '');
    //doc.setLineWidth(1);
    //doc.line(20, 50, 60, 20); // horizontal line
    //doc.line(100, 20, 100, 60); // vertical line
    var header = function (data) {
      doc.setFontSize(18);
      doc.setTextColor(40);
      doc.setFontStyle("normal");
      //doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
      //  doc.text("Testing Report", data.settings.margin.left, 50);
    };

    // var options = {
    //   beforePageContent: header,
    //   margin: {
    //     top: 60
    //   },
    //   startY: doc.autoTableEndPosY() + 20
    // };

    let exportJsonTemp = [];
    exportJsonTemp = this.exportJsonFormation(this.tripDetails);
    // doc.autoTable(getColumns, exportJsonTemp, options)

    doc.autoTable(getColumns, exportJsonTemp, {
      startY: 60,
      // startX: 20,
      tableLineColor: [189, 195, 199],
      tableLineWidth: 0.75,
      styles: {
        font: "Times New Roman",
        fillColor: [217, 217, 217],
        lineColor: [189, 195, 199],
        lineWidth: 0.25,
        textColor: 0,
        // fontSize: 8,cellWidth: 50,
        overflow: "linebreak",
        //columnWidth: 'wrap'
      },
      headerStyles: {
        fillColor: [217, 217, 217],
        fontSize: 10,
        textColor: 0,
        // fontSize: 8,cellWidth: 50,
        overflow: "linebreak",
        //columnWidth: 'wrap'
      },
      bodyStyles: {
        fillColor: [249, 249, 249],
        textColor: 0,
        overflow: "linebreak",
        //columnWidth: 'wrap'
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
        overflow: "linebreak",
        //columnWidth: 'wrap'
      },
      columnStyles: {
        // fontSize: 8,
        // fontSize: 8,cellWidth: 50,
        //  //columnWidth: 'wrap' ,
        text: { overflow: "linebreak" }, //columnWidth: 'wrap' },
        driver_id: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 45,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        sno: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 15,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        vehicle_no: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 60,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        start_time: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 54,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        end_time: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 54,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        worked_hours: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 40,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        over_time: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 30,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        overtime_duration: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 35,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        dinner_allowance: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 25,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
        holiday: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 20,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        start_address: {
          // fontStyle: 'italic',
          fontSize: 7,
          cellWidth: 60,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        end_address: {
          // fontStyle: 'italic',
          fontSize: 7,
          cellWidth: 60,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        outstation_start_time: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 54,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        outstation_end_time: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 54,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        outstation_workedhours: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 35,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        outstation_start_address: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 60,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        outstation_end_address: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 60,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },

        created_at: {
          // fontStyle: 'italic',
          fontSize: 8,
          cellWidth: 54,
          overflow: "linebreak",
          //columnWidth: 'wrap'
        },
      },
    });

    //   doc.autoTable(getColumns, exportJsonTemp, {
    //     startY: 60,
    //     margin: {horizontal: 7},
    //     bodyStyles: {valign: 'top'},
    //     styles: {overflow: 'linebreak', //columnWidth: 'wrap'},
    //     headerStyles: {fillColor: 10},
    //     columnStyles: {text: {//columnWidth: 'auto'}}
    // });
    // startY: doc.autoTableEndPosY() + 20
    //startY: doc.autoTable.previous.finalY + 1,
    doc.save("Driver Trips.pdf");
  }

  exportToExcel() {
    let exportJsonTemp = [];

    exportJsonTemp = this.exportJsonFormation(this.tripDetails);
    const workBook = XLSX.utils.book_new(); // create a new blank book

    const workSheet = XLSX.utils.json_to_sheet(exportJsonTemp);

    // ////console.log("EXCEL", exportJsonTemp);
    XLSX.utils.book_append_sheet(workBook, workSheet, "data"); // add the worksheet to the book
    XLSX.utils.book_append_sheet(workBook, {}, "consolidate"); // add the worksheet to the book

    XLSX.writeFile(workBook, "Driver Trips.xlsx");
  }

  reset() {
    this.initilization();
  }

  ngOnInit() {
    //let now = moment().format('LLLL');

    this.driverMap = new Map<String, String>();
    this.monthListMap = new Map<number, String>();
    this.monthDropDown = [{ mid: 0, month: "Select Month" }];
    this.addressListMap = new Map<String, Object>();
    this.addresses = [];
    this.totalItem = 0;
    this.delayinms = 0;
    this.loader = 3;
    this.driverusers = [];

    this.initilization();
    // this.spinnerService.show();
    this.filterDropDn = [
      { id: 0, name: "ALL" },
      { id: 1, name: "No" },
      { id: 2, name: "Yes" },
    ];
    this.displayValue = 0;

    this.cols = [{ field: "trip_id", header: "Vehicle Number" }];

    this.driverDropdownSettings = {
      singleSelection: true,
      idField: "id",
      textField: "user_name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    this.vehicleDropdownSettings = {
      singleSelection: true,
      idField: "vehicle_no",
      textField: "vehicle_no",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
    };

    // filter initilization
    this.driverSelectedItems = [];
    this.userSelectedItems = [];
    this.vehicleSelectedItems = [];
    this.tripDetails = [];
    // this.in_time = "";
    // this.out_time = "";
    this.out_station_flag = 0;
    this.out_time_flag = 0;
    this.month_excel_dwn = 0;
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  findOutStation(startTime, endTime) {
    var date1 = new Date(startTime);
    var date2 = new Date(endTime);
    if (date1.getDate() != date2.getDate()) {
      return "Yes";
    } else return "No";
  }

  nightAllowanceCal(trip) {
    trip.holiday = "N";
    trip.dinner_allowance = 0;
    let startstr = trip.duty_start.date_time;
    let endstr = trip.duty_end.date_time;

    var start = startstr.substring(0, 10);
    var end = endstr.substring(0, 10);
    var endtime = new Date(endstr).getTime();
    if (isNaN(endtime)) {
      return trip;
    }
    if (new Date(startstr).getDay() == 0 || new Date(endstr).getDay() == 0) {
      trip.holiday = "Y";
    }

    if (new Date(startstr).getDay() > new Date(endstr).getDay()) {
      trip.holiday = "Y";
    }

    let nightLimit = parseInt(endstr.substring(11, 13));
    if (start != end) {
      trip.dinner_allowance = 1;
      if (nightLimit > 20) {
        trip.dinner_allowance = trip.dinner_allowance + 1;
      }
      return trip;
    }

    //  let nightLimit = parseInt(endstr.substring(11, 13));
    //  nightLimit=parseInt(endstr.substring(9, 2));
    ////console.log("nightLimit", nightLimit)
    if (start == end && nightLimit > 20) {
      trip.dinner_allowance = 1;
      return trip;
    }
  }

  WorkedHrs(trip) {
    var timediff = 0;
    var outtimediff = 0;

    if (trip.trip_type == "2") {
      timediff =
        this.getmillsecdiff(
          trip.duty_start.date_time,
          trip.outstation_duty_start.date_time
        ) +
        this.getmillsecdiff(
          trip.outstation_duty_end.date_time,
          trip.duty_end.date_time
        );
      outtimediff = this.getmillsecdiff(
        trip.outstation_duty_start.date_time,
        trip.outstation_duty_end.date_time
      );
    } else {
      timediff = this.getmillsecdiff(
        trip.duty_start.date_time,
        trip.duty_end.date_time
      );
    }
    // var date1 = new Date("08/07/2018 23:41:20");
    // var date2 = new Date("08/08/2018 02:56:32");
    // var date1 = new Date(startTime);
    // var date2 = new Date(endTime);
    // var diff = this.get_timeDifference(timediff,overtimeflag);
    trip.worked_hrs = timediff == 0 ? "" : this.get_timeDifference(timediff, 0);
    trip.out_worked_hrs =
      outtimediff == 0 ? "" : this.get_timeDifference(outtimediff, 0);
    trip.overtime_worked_hrs =
      timediff == 0 ? "" : this.get_timeDifference(timediff, 1);
    trip.overtime = trip.overtime_worked_hrs == "" ? 1 : 2;
    return trip;
  }

  getmillsecdiff(stStr, endStr) {
    var milisec_diff = 0;
    var start = new Date(stStr).getTime();
    var end = new Date(endStr).getTime();
    if (isNaN(start) || isNaN(end)) {
      return 0;
    }
    if (start < end) {
      milisec_diff = end - start;
    }
    return milisec_diff;
  }

  get_timeDifference(milisec_diff, overtimeflag) {
    // var datetime = new Date(strtdatetime).getTime();
    // var now = new Date(enddatetime).getTime();
    // if (isNaN(datetime)) {
    //   return "";
    // }
    // if (datetime < now) {
    //   var milisec_diff = now - datetime;
    // } else {
    //   var milisec_diff = datetime - now;
    // }

    var days = Math.floor(milisec_diff / 1000 / 60 / (60 * 24));
    var date_diff = new Date(milisec_diff);
    var msec = milisec_diff;
    var hh = Math.floor(msec / 1000 / 60 / 60);
    msec -= hh * 1000 * 60 * 60;
    var mm = Math.floor(msec / 1000 / 60);
    msec -= mm * 1000 * 60;
    var ss = Math.floor(msec / 1000);
    msec -= ss * 1000;
    var daylabel = "";
    if (days > 0) {
      var grammar = " ";
      if (days > 1) grammar = "s ";
      var hrreset = days * 24;
      hh = hh - hrreset;
      daylabel = days + " Day" + grammar;
    }
    //  Format Hours
    var hourtext = "00";
    hourtext = String(hh);
    if (hourtext.length == 1) {
      hourtext = "0" + hourtext;
    }
    //  Format Minutes
    var mintext = "00";
    mintext = String(mm);
    if (mintext.length == 1) {
      mintext = "0" + mintext;
    }

    //  Format Seconds
    var sectext = "00";
    sectext = String(ss);
    if (sectext.length == 1) {
      sectext = "0" + sectext;
    }

    var msectext = "00";
    msectext = String(msec);
    msectext = msectext.substring(0, 1);
    if (msectext.length == 1) {
      msectext = "0" + msectext;
    }

    // let overtimeflag=1;
    let overtime: Boolean = false;
    let overtimeduration = "";

    if (overtimeflag == 1) {
      if (
        days > 0 ||
        parseInt(hourtext) > this.defaultWorkHr ||
        // (days < 0 && parseInt(hourtext) == this.defaultWorkHr && (parseInt(mintext) > 0 || parseInt(sectext) > 0 || parseInt(msectext) > 0))) {
        (days <= 0 && hh == this.defaultWorkHr && (ss > 0 || mm > 0))
      ) {
        //same day 12 hr plus some min
        if (days <= 0 && parseInt(hourtext) == this.defaultWorkHr) {
          overtimeduration = "00" + ":" + mintext + ":" + sectext; //+ ":" + msectext;
        } else if (days <= 0 && parseInt(hourtext) > this.defaultWorkHr) {
          //same day more than 12 hr plus/no min
          overtimeduration =
            parseInt(hourtext) -
            this.defaultWorkHr +
            ":" +
            mintext +
            ":" +
            sectext; //+ ":" + msectext;
        } else if (days > 0) {
          if (parseInt(hourtext) >= this.defaultWorkHr) {
            let str = "";
            overtimeduration = str.concat(
              `${daylabel}`,
              `${parseInt(hourtext) - this.defaultWorkHr}`,
              `${":"}`,
              `${mintext}`,
              `${":"}`,
              `${sectext}`
            ); //, `${":"}`, `${msectext}`);
          } else if (parseInt(hourtext) < this.defaultWorkHr) {
            let str = "";
            var diffDaylabel = "";
            if (days - 1 > 0) {
              var grammar = " ";
              if (days - 1 > 1) grammar = "s ";

              diffDaylabel = days - 1 + " Day" + grammar;
            }
            overtimeduration = str.concat(
              `${diffDaylabel}`,
              `${parseInt(hourtext) - this.defaultWorkHr + 24}`,
              `${":"}`,
              `${mintext}`,
              `${":"}`,
              `${sectext}`
            ); //, `${":"}`, `${msectext}`);
          }
        }
      }
      ////console.log("overtimeduration", overtimeduration)
      return overtimeduration;
    }

    return daylabel + hourtext + ":" + mintext + ":" + sectext; //+ ":" + msectext;
  }

  exportJsonFormation(tripList) {
    let dateFormat = require("dateformat");
    let tripDetailsexport: any = [];
    let exportJsonTemp = [];
    //let exportJsonData:any;
    tripList.forEach((trip) => {
      let exJson: any = {};
      exJson.sno = trip.sno;
      exJson.vehicle_no = trip.vehicle_no;
      exJson.driver_id = trip.driver.user_name + " " + trip.driver.name;
      exJson.start_time =
        trip.duty_start.date_time != "-"
          ? dateFormat(trip.duty_start.date_time, "yyyy-mm-dd HH:MM:ss")
          : "";
      exJson.end_time =
        trip.duty_end.date_time != "-"
          ? dateFormat(trip.duty_end.date_time, "yyyy-mm-dd HH:MM:ss")
          : "";
      exJson.worked_hours = trip.worked_hrs;
      exJson.over_time = trip.overtime == 2 ? "Yes" : "No";
      exJson.overtime_duration = trip.overtime_worked_hrs;
      exJson.dinner_allowance = trip.dinner_allowance;
      exJson.holiday = trip.holiday == "Y" ? "Yes" : "No";
      exJson.start_address = trip.duty_start.address;
      exJson.end_address = trip.duty_end.address;
      exJson.is_outstation = trip.trip_type == 2 ? "Yes" : "No";
      exJson.outstation_start_time =
        trip.outstation_duty_start != null
          ? trip.outstation_duty_start.date_time != "-"
            ? dateFormat(
                trip.outstation_duty_start.date_time,
                "yyyy-mm-dd HH:MM:ss"
              )
            : ""
          : "";
      exJson.outstation_end_time =
        trip.outstation_duty_end != null
          ? trip.outstation_duty_end.date_time != "-"
            ? dateFormat(
                trip.outstation_duty_end.date_time,
                "yyyy-mm-dd HH:MM:ss"
              )
            : ""
          : "";
      exJson.outstation_workedhours = trip.out_worked_hrs;
      exJson.outstation_start_address =
        trip.outstation_duty_start != null
          ? trip.outstation_duty_start.address
          : "";
      exJson.outstation_end_address =
        trip.outstation_duty_end != null
          ? trip.outstation_duty_end.end_address
          : "";
      exJson.duty_start_device_id =
        trip.duty_start_device_id != null ? trip.duty_start_device_id : "";
      exJson.duty_end_device_id =
        trip.duty_end_device_id != null ? trip.duty_end_device_id : "";
      exJson.duty_start_device_details =
        trip.duty_start_device_details != null
          ? trip.duty_start_device_details.replace(/<br \/>/g, ", \n")
          : "";
      exJson.duty_end_device_details =
        trip.duty_end_device_details != null
          ? trip.duty_end_device_details.replace(/<br \/>/g, ", \n")
          : "";
      exJson.created_at = dateFormat(trip.created_at, "yyyy-mm-dd HH:MM:ss");
      exportJsonTemp.push(exJson);
    });

    let exJson: any = {};

    exJson.worked_hours = this.tlduration;
    exJson.overtime_duration = this.tloverduration;
    exJson.outstation_workedhours = this.tloutduration;
    exportJsonTemp.push(exJson);

    return exportJsonTemp;
  }

  // positionNullCheck(position) {
  //   let lat = position.lat != null ? position.lat : "";
  //   let long = position.long != null ? "," + position.long : "";

  //   return lat + long
  // }

  sortBy(propertyName) {
    this.reverse = this.propertyName === propertyName ? this.reverse : false;
    this.propertyName = propertyName;
  }

  initilization() {
    this.filterError = false;
    this.filterErrorAgency = false;
    let dateFormat = require("dateformat");
    this.in_time = dateFormat(new Date(), "yyyy-mm-dd");
    this.out_time = "";

    // this.monthDropDown = [{ mid: 0, month: "Select Month" }];
    this.driverSelectedItems = [];
    this.userSelectedItems = [];
    this.vehicleSelectedItems = [];
    this.tripDetails = [];
    this.out_station_flag = 0;
    this.month_excel_dwn = 0;
    this.out_time_flag = 0;
    this.consolidatedInit();
    // this.monthDropDown = [{ id: 0, month: "Select Month" }];
    // this.monthFilter();
  }

  consolidatedInit() {
    this.dayval = 0;
    this.hrval = 0;
    this.minval = 0;
    this.secval = 0;

    this.overdayval = 0;
    this.overhrval = 0;
    this.overminval = 0;
    this.oversecval = 0;

    this.outdayval = 0;
    this.outhrval = 0;
    this.outminval = 0;
    this.outsecval = 0;

    this.tlduration = "";
    this.tloverduration = "";
    this.tloutduration = "";
  }
  onSelectAll(event) {
    ////console.log("multiselect")
  }

  highLightSunday(isSunday) {
    if (isSunday == "Y") {
      return "#689 !important;";
    }
  }

  onItemSelect(event) {
    ////console.log("event", event)
  }

  sortinglist(tripList, n) {
    const sorted = tripList.sort((t1, t2) => {
      const date1 = t1.duty_start.date_time;
      const date2 = t2.duty_start.date_time;
      var start = new Date(date1).getTime();
      var end = new Date(date2).getTime();
      if (n == 1) {
        if (start > end) {
          return -1;
        }
        if (start < end) {
          return 1;
        }
        return 0;
      } else {
        if (start > end) {
          return 1;
        }
        if (start < end) {
          return -1;
        }
        return 0;
      }
    });

    return sorted;
  }

  sortingDriver(tripList) {
    const sorted = tripList.sort((t1, t2) => {
      const driver1 = t1.driver.user_name;
      const driver2 = t2.driver.user_name;
      // var start = new Date(date1).getTime();
      // var end = new Date(date2).getTime();
      ////console.log("start", date1)
      ////console.log("end", date2)
      ////console.log("start > end", start > end)
      ////console.log("start > end", start < end)
      if (driver1 > driver2) {
        return -1;
      }
      if (driver1 < driver2) {
        return 1;
      }
      return 0;
    });

    return sorted;
  }

  sortingDriverName(tripList) {
    const sorted = tripList.sort((t1, t2) => {
      const driver1 = t1.driver_name;
      const driver2 = t2.driver_name;
      if (driver1 > driver2) {
        return -1;
      }
      if (driver1 < driver2) {
        return 1;
      }
      return 0;
    });

    return sorted;
  }

  enlat() {
    this.tripDetails.forEach((vhl) => {
      let s_address = vhl.duty_start.address;
      let e_address = vhl.duty_end.address;
      let os_address = vhl.outstation_duty_start.address;
      let oe_address = vhl.outstation_duty_end.address;
      let s_date = vhl.duty_start.date_time;
      let e_date = vhl.duty_end.date_time;
      let os_date = vhl.outstation_duty_start.date_time;
      let oe_date = vhl.outstation_duty_end.date_time;

      this.awserviceProvider
        .updaterm(
          vhl.trip_id,
          s_address,
          e_address,
          os_address,
          oe_address,
          s_date,
          e_date,
          os_date,
          oe_date
        )
        .then((id) => {
          //console.log("UODATED", id)
        });
    });
  }

  dateFormatConversion() {}

  expConsolidatedRpt() {
    let dateFormat = require("dateformat");
    let reportDates = [];
    // start of calculating the no of days present in the report
    // Start and End and No of Days
    var intime = new Date(this.in_time).getTime();
    if (this.out_time == "") {
      var today = new Date().getTime() + 86400000;
      var tomorrow = new Date(today);
      var datedate = dateFormat(tomorrow.toDateString(), "yyyy-mm-dd");
      this.out_time = datedate;
    }
    var outtime = new Date(this.out_time).getTime();
    var totalnoofdays: number = (outtime - intime) / 86400000;

    // End of calculating the no of days present in the report

    // start of creating array to store the report date values
    var i: number = 0;
    for (i = 0; i <= totalnoofdays; i++) {
      var ms = new Date(intime).getTime() + 86400000 * i;
      var mst = new Date(ms);
      var date = dateFormat(mst.toDateString(), "yyyy-mm-dd");
      reportDates.push(date);
    }
    // End of creating array to store the report date values

    //sorting the display list
    var trips = this.sortinglist(this.tripDetails, -1);
    var sortedData: any[] = ([] = this.sortingDriver(trips));
    var j: number = 0;
    var k: number = 0;
    var count: number = 0;
    var dataraw = [];
    var predriver = "";
    var prevdate = "";

    var drivercnt: number = 0;
    var driverarray = [];
    var driverloopcnt = 0;
    var dateAvailable = 0;
    this.uniquedriver = [];

    const map = new Map();
    sortedData.forEach((res) => {
      if (!map.has(res.driver.user_name)) {
        map.set(res.driver.user_name, true); // set any value to Map
        this.uniquedriver.push(res.driver.user_name);
      }
    });

    for (j = 0; j < reportDates.length; j++) {
      this.uniquedriver.forEach((unique) => {
        driverarray = sortedData.filter(
          (elm) => elm.driver.user_name == unique
        );
        driverloopcnt = 0;
        dateAvailable = 0;
        driverarray.forEach((res) => {
          driverloopcnt++;
          console.log("---------------------res", res);
          if (res.duty_start.date_time.substring(0, 10) == reportDates[j]) {
            dataraw.push({
              user_name: res.guest.user_id + `-` + res.guest.user_name,
              driver_name: res.driver.user_name + `-` + res.driver.name,
              date: res.duty_start.date_time.substring(0, 10),
              time_from:
                res.duty_start.date_time != "-"
                  ? dateFormat(res.duty_start.date_time, "yyyy-mm-dd HH:MM:ss")
                  : "",
              time_to:
                res.duty_end.date_time != "-"
                  ? dateFormat(res.duty_end.date_time, "yyyy-mm-dd HH:MM:ss")
                  : "",
              out_al: res.outstation_duty_start.address,
            });
            dateAvailable = 1;
          } else {
            if (driverloopcnt == driverarray.length && dateAvailable == 0) {
              dataraw.push({
                user_name: res.guest.user_id + `-` + res.guest.user_name,
                driver_name: res.driver.user_name + `-` + res.driver.name,
                date: reportDates[j],
                time_from: reportDates[j] + " 00:00:00",
                time_to: reportDates[j] + " 00:00:00",
                out_al: "-",
              });
            }
          }
          // //console.log("inside", dataraw);
        });
      });
    }
    //console.log("dataraw", dataraw);

    this.ExcelFormation(dataraw);
  }

  // sortedData.forEach(data => {
  // var dataraw = [];
  //   dataraw.push({
  //     driver_name: data.driver.user_name + `-` + data.driver.name,
  //     date: data.duty_start.date_time.substring(0, 10),
  //     time_from: data.duty_start.date_time != "-" ? dateFormat(data.duty_start.date_time, "yyyy-mm-dd HH:MM:ss") : '',
  //     time_to: data.duty_end.date_time != "-" ? dateFormat(data.duty_end.date_time, "yyyy-mm-dd HH:MM:ss") : '',
  //     out_al: data.outstation_duty_start.address
  //   });

  // });

  headercreation(rawdata) {
    var dataraw = ([] = rawdata);
  }

  headerInsertion(headercell, ws) {
    var HAcell = `A` + headercell;
    var HBcell = `B` + headercell;
    var HCcell = `C` + headercell;
    var HDcell = `D` + headercell;
    var HEcell = `E` + headercell;
    var HFcell = `F` + headercell;
    var HGcell = `G` + headercell;
    var HHcell = `H` + headercell;
    var HIcell = `I` + headercell;
    var HJcell = `J` + headercell;
    var HKcell = `K` + headercell;
    var HLcell = `L` + headercell;
    var HMcell = `M` + headercell;
    var HNcell = `N` + headercell;
    var HOcell = `O` + headercell;
    var HPcell = `P` + headercell;
    var HQcell = `Q` + headercell;
    var HRcell = `R` + headercell;
    ws[HAcell] = { v: "DRIVER NAME" };
    ws[HBcell] = { v: "DATE" };
    ws[HCcell] = { v: "TIME From" };
    ws[HDcell] = { v: "TIME To" };
    ws[HEcell] = { v: "OUTSTATION ALLOWANCE" };
    ws[HFcell] = { v: "OUTSTATION ALLOWANCE AMT" };
    ws[HGcell] = { v: "TOTAL HRS" };
    ws[HHcell] = { v: "OT HRS" };
    ws[HIcell] = { v: "Holidays / Sundays" };
    ws[HJcell] = { v: "OT Amount" };
    ws[HKcell] = { v: "LATE NIGHT ALLOWANCE (hrs)" };
    ws[HLcell] = { v: "NIGHT ALLOWANCE Rs." };
    ws[HMcell] = { v: "Total" };
    ws[HNcell] = { v: "esi on voti" };
    ws[HOcell] = { v: "REMARKS" };
    ws[HPcell] = { v: "Attendance" };
    ws[HQcell] = { v: "Present" };
    ws[HRcell] = { v: "Daily Amt" };
  }

  sumInsertion(start, n, x, ws) {
    var FSumCell = `F` + x;
    var GSumCell = `G` + x;
    var HSumCell = `H` + x;
    var ISumCell = `I` + x;
    var JSumCell = `J` + x;
    var KSumCell = `K` + x;
    var LSumCell = `L` + x;
    var MSumCell = `M` + x;
    var NSumCell = `N` + x;
    var QSumCell = `Q` + x;
    var RSumCell = `R` + x;
    var Total = x + 1;
    var TotalA = `A` + Total;
    var TotalB = `B` + Total;

    ws[FSumCell] = { f: `=SUM(F` + start + `:F` + n + `)` };
    ws[GSumCell] = { f: `=SUM(G` + start + `:G` + n + `)` };
    ws[HSumCell] = { f: `=SUM(H` + start + `:H` + n + `)` };
    ws[ISumCell] = { f: `=SUM(I` + start + `:I` + n + `)` };
    ws[JSumCell] = { f: `=SUM(J` + start + `:J` + n + `)` };
    ws[KSumCell] = { f: `=SUM(K` + start + `:K` + n + `)` };
    ws[LSumCell] = { f: `=SUM(L` + start + `:L` + n + `)` };
    ws[MSumCell] = { f: `=SUM(M` + start + `:M` + n + `)` };
    ws[NSumCell] = { f: `=SUM(N` + start + `:N` + n + `)` };
    ws[QSumCell] = { f: `=SUM(Q` + start + `:Q` + n + `)` };
    ws[RSumCell] = { f: `=SUM(R` + start + `:R` + n + `)` };
    ws[GSumCell].z = "[h]:mm:ss";
    ws[HSumCell].z = "[h]:mm:ss";
    // ws[KSumCell].z = '[h]:mm:ss';
    ws[TotalA] = { v: `TOTAL WAGES` };
    ws[TotalB] = {
      f: `=I` + x + `+J` + x + `+L` + x + `+F` + x + `+R` + x + `+N` + x,
    };
  }

  contentDataFormation(n, data, ws) {
    var Acell = `A` + n;
    var Bcell = `B` + n;
    var Ccell = `C` + n;
    var Dcell = `D` + n;
    var Ecell = `E` + n;
    var Fcell = `F` + n;
    var Gcell = `G` + n;
    var Hcell = `H` + n;
    var Icell = `I` + n;
    var Jcell = `J` + n;
    var Kcell = `K` + n;
    var Lcell = `L` + n;
    var Mcell = `M` + n;
    var Ncell = `N` + n;
    var Pcell = `P` + n;
    var Qcell = `Q` + n;
    var Rcell = `R` + n;

    ws[Acell] = { v: data.driver_name };
    ws[Bcell] = { v: data.date };
    ws[Ccell] = { v: data.time_from };
    ws[Dcell] = { v: data.time_to };
    ws[Ecell] = { v: data.out_al };
    ws[Fcell] = { f: `=IF(E` + n + `="-",0,550)` };
    ws[Gcell] = { f: `=D` + n + `-C` + n };
    ws[Hcell] = { f: `=IF(G` + n + `>CONFIG!$A$2,G` + n + `-CONFIG!$A$2,0)` };
    ws[Icell] = { f: `=IF(G` + n + `>0,1,)*450` };
    ws[Jcell] = { f: `=(H` + n + `)*60*24` };
    ws[Kcell] = { f: `=HOUR(D` + n + `)` };
    ws[Lcell] = { f: `=IF(K` + n + `>20,1,)*50` };
    ws[Mcell] = { f: `=J` + n + `+L` + n + `+F` + n + `+I` + n };
    ws[Ncell] = { f: `=+J` + n + `*4.75%` };
    ws[Pcell] = {
      f:
        `=IF(G` +
        n +
        `,"1",0) & IF(O` +
        n +
        ` = "REST",1,0) & IF(O` +
        n +
        `="G.O.O.S",1,0) & IF(O` +
        n +
        `="LOP",0,0)&IF(O` +
        n +
        `="spare",1,0)`,
    };
    ws[Qcell] = { f: `=IF(P` + n + `="00000",0,1)` };
    ws[Rcell] = { f: `=SUM(CONFIG!$D$2/CONFIG!$C$2)*Q` + n };

    //  ws[Ocell] = { f: };
    ws[Ccell].z = "[h]:mm:ss";
    ws[Dcell].z = "[h]:mm:ss";
    ws[Gcell].z = "[h]:mm:ss";
    ws[Hcell].z = "[h]:mm:ss";
  }

  consolidateHeader() {
    var consolidateColumn = {
      sno: "S NO",
      pc_no: "PC NO",
      driver_name: "Driver name ",
      guest__emp_no: "Guest Employee Number",
      original_name: "Original Name",
      cost_center: "Cost Centre Code",
      groups_cost_center: "Group as per cost center",
      no_of_days_worked: "No Of Days Worked",
      present_sal: "Present Salary ",
      earned_sal: "Earned Salary (A)",
      normal_ot: "NORMAL OT",
      ot_amt: "OT Amount (B)",
      esi: "ESI @ 4.75%",
      sunday: "SUNDAY/HOLIDAY AMT",
      night: "L,Night Allow",
      outstation: "O,Station Allow",
      gross: "Gross Total",
      gst: "GST Tax @ 18%",
      ctc: "CTC",
      sec: "SEZ/DTA",
      plant: "Plant Code",
      gst_in: "GSTIN Number",
    };

    var consolidatedData = [];
    consolidatedData.push(consolidateColumn);
    var wsconsolidate = this.uigrid_to_sheet(consolidatedData);
    wsconsolidate["!ref"] = XLSX.utils.encode_range({
      s: { c: 0, r: 0 },
      // e: { c: 7, r: 1 + parsed.length + 1 }
      e: { c: 20, r: 1 + this.uniquedriver.length * 2 },
    });
    return wsconsolidate;
  }

  //consolidated report sheet row number
  // MIS sum number
  consolidateData(wsconsolidate, m, driver_name, sumnumber, user_name) {
    var CHcell = `H` + m;
    var CCcell = `C` + m;
    var CDcell = `D` + m;
    var CIcell = `I` + m;
    var CJcell = `J` + m;
    var CKcell = `K` + m;
    var CLcell = `L` + m;
    var CMcell = `M` + m;
    var CNcell = `N` + m;
    var COcell = `O` + m;
    var CPcell = `P` + m;
    var CQcell = `Q` + m;
    var CRcell = `R` + m;
    var CScell = `S` + m;
    wsconsolidate[CCcell] = { v: driver_name };
    wsconsolidate[CDcell] = { v: user_name };
    wsconsolidate[CHcell] = { f: `=MIS!Q` + sumnumber };
    wsconsolidate[CIcell] = { f: `=CONFIG!$D$2` };
    wsconsolidate[CJcell] = { f: `=I` + m + `/30*H` + m };
    wsconsolidate[CKcell] = { f: `=MIS!H` + sumnumber };
    wsconsolidate[CLcell] = { f: `=MIS!J` + sumnumber };
    wsconsolidate[CMcell] = { f: `=L` + m + `*4.75%` };
    wsconsolidate[CNcell] = { f: `=MIS!I` + sumnumber };
    wsconsolidate[COcell] = { f: `=MIS!L` + sumnumber };
    wsconsolidate[CPcell] = { f: `=MIS!F` + sumnumber };
    wsconsolidate[CQcell] = {
      f: `=P` + m + `+O` + m + `+L` + m + `+J` + m + `+N` + m + `+M` + m,
    };
    wsconsolidate[CRcell] = { f: `=Q` + m + `*18%` };
    wsconsolidate[CScell] = { f: `=Q` + m + `+R` + m };
    wsconsolidate[CKcell].z = "[h]:mm:ss";
  }

  ExcelFormation(rawdata) {
    var dataraw = ([] = this.sortingDriverName(rawdata));
    var wb = XLSX.utils.book_new();
    var configSheetName = "CONFIG";
    var sheetName = "MIS";
    // var cofigColumn = [{'WORKING_HOURS', 'NIGHT_LIMIT', 'NO OF WORKING DAYS', 'MONTHLY SAL'}]
    var cofigData = [
      {
        working_hours: "WORKING_HOURS",
        night_limit: "NIGHT_LIMIT",
        no_of_work: "NO OF WORKING DAYS",
        monthly_sal: "MONTHLY SAL",
      },
      {
        working_hours: `12:00:00`,
        night_limit: "20:59:59",
        no_of_work: 30,
        monthly_sal: 20889.16,
      },
    ];

    var wsc = this.uigrid_to_sheet(cofigData);
    wsc["A2"].z = "[h]:mm:ss";
    wsc["B2"].z = "[h]:mm:ss";
    XLSX.utils.book_append_sheet(wb, wsc, configSheetName);
    var header = [];
    // var cntstart = 2;
    header.push({
      driver_name: "DRIVER NAME",
      date: "DATE",
      time_from: "TIME From",
      time_to: "TIME To",
      out_al: "OUTSTATION ALLOWANCE",
      out_al_amt: "OUTSTATION ALLOWANCE AMT",
      tot_hrs: "TOTAL HRS",
      ot_hrs: "OT HRS",
      holiday_sun: "Holidays / Sundays",
      ot_amt: "OT Amount",
      lat_nit_al: "LATE NIGHT ALLOWANCE (hrs)",
      nit_al_amt: "NIGHT ALLOWANCE Rs.",
      tot: "Total",
      esi_on_ot: "esi on voti",
      remarks: "REMARKS",
      attend: "Attendance",
      present: "Present",
      dailyamt: "Daily Amt",
    });

    var ws = this.uigrid_to_sheet(header);
    ws["!ref"] = XLSX.utils.encode_range({
      s: { c: 0, r: 0 },
      // e: { c: 7, r: 1 + parsed.length + 1 }
      e: { c: 20, r: 1 + dataraw.length * 2 },
    });
    var i: number = 0;
    var driverdata = [];
    var start: number = 2;
    var cnt: number = 0;
    var n: number = 0;
    var wsconsolidate = this.consolidateHeader();
    var currentUniqueNumber = 2;
    this.uniquedriver.forEach((element) => {
      driverdata = dataraw.filter(
        (elm) => elm.driver_name.substring(0, element.length) == element
      );
      for (i = 0; i < driverdata.length; i++) {
        n = start + i;
        if (start != 2) {
          var headercell = start - 1;
          this.headerInsertion(headercell, ws);
        }
        this.contentDataFormation(n, driverdata[i], ws);
        cnt++;
        if (i == driverdata.length - 1) {
          var x = start + driverdata.length;
          this.sumInsertion(start, n, x, ws);
          start = start + driverdata.length + 4;
          cnt = 0;
          this.consolidateData(
            wsconsolidate,
            currentUniqueNumber,
            driverdata[i].driver_name,
            x,
            driverdata[i].user_name
          );
          currentUniqueNumber++;
        }
      }
    });

    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    XLSX.utils.book_append_sheet(wb, wsconsolidate, "invoiceTS COPY");
    XLSX.writeFile(wb, "Official SSC Drivers Bill.xlsx");
  }

  uigrid_to_sheet(data) {
    var o = [],
      oo = [],
      i = 0,
      j = 0;
    return XLSX.utils.json_to_sheet(data, { skipHeader: true });
  }

  // expConsolidatedRpt2() {
  //   let dateFormat = require('dateformat');
  //   let reportDates = [];
  //   // start of calculating the no of days present in the report
  //   // Start and End and No of Days
  //   var intime = new Date(this.in_time).getTime();
  //   if (this.out_time == "") {
  //     var today = new Date().getTime() + 86400000;
  //     var tomorrow = new Date(today);
  //     var datedate = dateFormat(tomorrow.toDateString(), "yyyy-mm-dd");
  //     this.out_time = datedate;
  //   }
  //   var outtime = new Date(this.out_time).getTime();
  //   var totalnoofdays: number = (outtime - intime) / 86400000;

  //   // End of calculating the no of days present in the report

  //   // start of creating array to store the report date values
  //   var i: number = 0;
  //   for (i = 0; i <= totalnoofdays; i++) {
  //     var ms = new Date(intime).getTime() + (86400000 * i);
  //     var mst = new Date(ms);
  //     var date = dateFormat(mst.toDateString(), "yyyy-mm-dd");
  //     reportDates.push(date)
  //   }

  //   // End of creating array to store the report date values

  //   //sorting the display list
  //   var trips = this.sortinglist(this.tripDetails, -1);
  //   var sortedData: any[] = [] = this.sortingDriver(trips);
  //   var j: number = 0;
  //   var k: number = 0;
  //   var count: number = 0;
  //   var dataraw = [];
  //   var predriver = "";
  //   var prevdate = "";

  //   for (j = 0; j < sortedData.length; j++) {
  //     //console.log("COUNT", count);
  //     //console.log("predriver", predriver);
  //     if (count == reportDates.length) { count = 0; }
  //     predriver = j != 0 ? sortedData[j - 1].driver.user_name + `-` + sortedData[j].driver.name : "";
  //     // prevdate = sortedData[j].duty_start.date_time.substring(0, 10);
  //     var current = sortedData[j].duty_start.date_time != "-" ? dateFormat(sortedData[j].duty_start.date_time, "yyyy-mm-dd") : '';
  //     if (current != reportDates[count]) {
  //       var start = new Date(reportDates[count]).getTime();
  //       var end = new Date(current).getTime();
  //       var dif: number = (end - start) / 86400000;
  //       var l: number = 0;
  //       for (l = 0; l < dif; l++) {
  //         dataraw.push({
  //           driver_name: sortedData[j].driver.user_name + `-` + sortedData[j].driver.name,
  //           date: reportDates[count],
  //           time_from: reportDates[count] + ' 00:00:00',
  //           time_to: reportDates[count] + ' 00:00:00',
  //           out_al: '-'
  //         });
  //         count++;
  //       }

  //     }
  //     dataraw.push({
  //       driver_name: sortedData[j].driver.user_name + `-` + sortedData[j].driver.name,
  //       date: sortedData[j].duty_start.date_time.substring(0, 10),
  //       time_from: sortedData[j].duty_start.date_time != "-" ? dateFormat(sortedData[j].duty_start.date_time, "yyyy-mm-dd HH:MM:ss") : '',
  //       time_to: sortedData[j].duty_end.date_time != "-" ? dateFormat(sortedData[j].duty_end.date_time, "yyyy-mm-dd HH:MM:ss") : '',
  //       out_al: sortedData[j].outstation_duty_start.address
  //     });

  //     if (prevdate != sortedData[j].duty_start.date_time.substring(0, 10)) { count++; }
  //     prevdate = sortedData[j].duty_start.date_time.substring(0, 10);

  //     // if new driver list starts checking to find the difference between report date count and looped count
  //     if ((predriver != "" && predriver != (sortedData[j].driver.user_name + `-` + sortedData[j].driver.name)) || j == sortedData.length - 1) {

  //       if (count != reportDates.length) {
  //         var diff = reportDates.length - count;

  //         for (var km = 0; km < diff; km++) {
  //           count++;
  //           dataraw.push({
  //             driver_name: predriver,
  //             date: reportDates[count],
  //             time_from: reportDates[count] + ' 00:00:00',
  //             time_to: reportDates[count] + ' 00:00:00',
  //             out_al: '-'
  //           });
  //         }
  //       }

  //     }

  //   }

  //   this.ExcelFormation(dataraw);
  // }
}
